import { unescapeTag } from './escape';
import * as lexical from './lexical';

export const RAW_LIQUID_TAG = 'raw';

/**
 * Parse a literal value.
 */
function parseLiteral(str: string) {
    if (str.match(lexical.numberLine)) {
        return Number(str);
    }
    if (str.match(lexical.boolLine)) {
        return str.toLowerCase() === 'true';
    }
    if (str.match(lexical.quotedLine)) {
        return unescapeTag(str.slice(1, -1));
    }

    return str;
}

/**
 * Parse properties of the block.
 */
export function parseLiquidProperties(inputText: string) {
    let match: RegExpMatchArray | null;
    let args = 0;
    const result: { [key: string]: string | number | boolean } = {};

    let text = inputText;
    do {
        match = text.match(lexical.prop);

        if (match) {
            if (match[2]) {
                result[match[2]] = parseLiteral(match[3]);
            } else {
                result[args] = parseLiteral(match[1]);
                args += 1;
            }

            text = text.slice(match[0].length);
        }
    } while (match);

    return result;
}
